<template>
  <div class="panel-box" :style="{'margin-bottom': (data.marginBottom) / 16 + 'rem'}">
    <h2>
      <p class="title">{{ data.title }}</p>
      <p v-if="data.showSubTitle" class="subtitle" @click="handleSubEvent">
        <span>{{ data.subTitle }}</span>
        <img class="title-icon" :src="data.subImgUrl">
      </p>
    </h2>
    <div class="panel-content">
      <!-- 问题列表 -->
      <div v-if="data.showType === 'list'" class="panel-content-list">
        <ul>
          <li v-for="(item, index) in showQesList" :key="index" class="each-question" @click="handleClick(item)">
            <p>{{ item.eachQ }}</p>
            <img
              class="icon"
              src="https://www.haohuan.com/datahub/file/2021-07/6b58662a6319698797a741e351366e41.png"
            >
          </li>
        </ul>
      </div>
      <!-- 入口icon -->
      <div v-if="data.showType === 'icon'" class="panel-content-icon">
        <ul>
          <li v-for="(eachItem, eachIndex) in data.icons" :key="eachIndex" @click="handleIconClick(eachItem)">
            <span v-if="eachItem.tipText" class="tip">{{ eachItem.tipText }}
              <i />
            </span>
            <div class="icon">
              <img :src="eachItem.iconUrl" alt="">
            </div>
            <p>{{ eachItem.title }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 底部弹窗 -->
    <div v-if="isShowPopup" class="popup-abs">
      <div class="pupup-mask" :style="{ height: (screenHeight ) / 16 + 'rem'/*no*/}">
        <div class="popup-bottom">
          <img
            class="popup-bottom-close"
            src="https://datahub.haohuan.com/gfs/2021-12/a8a6ec5f4f7e5d91e62c56fe74eb41bc.png"
            @click="handleCloseClick"
          >
          <p class="popup-bottom-question">{{ popupData.eachQ }}</p>
          <p class="popup-bottom-answer" v-html="popupData.eachA" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelBox",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      isShowPopup: false,
      popupData: {},
      showQesList: [],
      screenHeight: document.documentElement.clientHeight
    }
  },
  watch: {
    'data.sliceNum'(val) {
      this.showQesList = this.data.questionList.slice(0, val);
    }
  },
  mounted() {
    if (this.data.isSlice) {
      this.showQesList = this.data.questionList.slice(0, this.data.sliceNum);
    } else {
      this.showQesList = this.data.questionList;
    }
  },
  methods: {
    handleClick(item) {
      let curElement = document.querySelector('body');
      curElement.style.overflow = 'hidden';
      this.isShowPopup = true;
      this.popupData = item;
    },
    handleCloseClick() {
      let curElement = document.querySelector('body');
      curElement.style.overflow = '';
      this.isShowPopup = false;
    },
    handleSubEvent() {
      this.showQesList = this.getListRandom(this.data.questionList, this.data.sliceNum);
    },
    getListRandom(arr, count) {
      // eslint-disable-next-line
      let shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },
    handleIconClick(item) {
      window.location.href = item.link;
    }
  }
}
</script>

<style lang="less" scoped>
.panel-box {
  width: 100%;
  h2 {
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    height: 48px;
    line-height: 48px;
    background: #FBFBFD;
    box-shadow: 0px 2px 10px 0px rgba(226, 228, 236, 0.3);
    border-radius: 8px 8px 0 0;
    font-size: 17px;
    .title {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #2E2E33;
    }
    .subtitle {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #C6CACE;
      .title-icon {
        width: 16px;
        height: 16px;
        margin-left: 6px;
      }
    }
  }
  .panel-content {
    padding: 8px 0 10px;
    background: #fff;
    border-radius: 0 0 8px 8px;
    &-list {
      .each-question {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      li {
        position: relative;
        padding: 0 16px;
        height: 46px;
        line-height: 46px;
        font-size: 13px;
        color: #2E2E33;
        p {
          max-width: 247px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-family: PingFangSC-Regular, PingFang SC;
        }
        .icon {
          width: 12px;
          height: 12px;
        }
      }
    }
    &-icon {
      ul {
        display: flex;
        justify-content: space-between;
        background: #fff;
        border-radius: 0 0 8px 8px;
        li {
          width: 88px;
          height: 87px;
          position: relative;
          .tip {
            position: absolute;
            left: 44px;
            top: 12px;
            padding: 3px 4px;
            font-size: 8px;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #FFFFFF;
            line-height: 8px;
            background: #FF3838;
            border-radius: 8px;
            border: 1px solid #FFFFFF;
            i {
              position: absolute;
              width: 10px;
              height: 4px;
              bottom: -3px;
              left: 0px;
              background: url(https://datahub.haohuan.com/gfs/2021-12/5fabc4faf7f403bc69ac065a97f2f2be.png) no-repeat;
              background-size: 10px 3px;
            }
          }
          .icon {
            margin: 12px auto 0;
            width: 40px;
            height: 40px;
            img {
              width: 100%;
            }
          }
          p {
            font-size: 13px;
            color: #2E2E33;
            line-height: 19px;
            text-align: center;
          }
          &:last-child {
            width: 87px;
          }
        }
      }
    }
  }
  .popup-abs {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .pupup-mask {
    position: sticky;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5)
  }
  .popup-bottom {
    position: fixed;
    z-index: 2;
    bottom: 0;
    height: 400px;
    background: #fff;
    padding: 0 20px;
    width: 100%;
    &-close {
      float: right;
      margin: 10px 0;
      width: 20px;
      height: 20px;
    }
    &-question {
      position: relative;
      margin-top: 40px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #2E2E33;
      line-height: 26px;
      text-align: justify;
      padding-bottom: 9px;
      &::after {
        content: " ";
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        height: 0.026667rem;
        border-bottom: 0.026667rem solid #C7C7C7;
        color: #C7C7C7;
        -webkit-transform-origin: 0 100%;
        transform-origin: 0 100%;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }
    &-answer {
      padding: 12px 0;
      font-size: 14px;
      line-height: 22px;
      text-align: justify;
      overflow-y: scroll;
      color: #919199;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
